import { useCallback, useContext, useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import StoreContext from "../context/StoreContext";
import debounce from "lodash.debounce";
import PropTypes from 'prop-types';
import { useBebackApi } from "../hooks/useBebackApi";

function MRLocationSearch ({ onSelect, label, variant, size, error, value }) {
  const { validateAddress } = useBebackApi();
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { address } = useContext(StoreContext)
  const [enableInput, setEnableInput] = useState(false)

  const handleSearch = useCallback(
    debounce(async (value, reason) => {
      if (!value) {
        onSelect('');
        setOptions([]);
        return;
      }
      
      // Prevent API call after select an option
      if(reason === 'reset')
        return
      
      setLoading(true);
      try {
        const data = await validateAddress({
          addressQuery: value,
          lng: address.lng,
          lat: address.lat
        })

        // add an id for stable identity
        const mapped = data.map((item, idx) => ({
          id: `${item.coordinates.join(",")}-${idx}`,
          label: item.label,
          coordinates: item.coordinates
        }));

        if (JSON.stringify(mapped) !== JSON.stringify(options)) {
          setOptions(mapped);
        }

      } catch (error) {
        console.error("API error:", error);
      } finally {
        setLoading(false);
      }
    }, 1000),
  []);

    const handleSelect = async (place) => {
      if(!place) {
        onSelect('');
        return;
      }
      setOptions([]);
      if (onSelect) onSelect(place); 
    };

  return (
    <Autocomplete
      size={size}
      value={value || ""}
      freeSolo
      options={options}
      filterOptions={(options) => options}
      getOptionLabel={(opt) => 
        typeof opt === "string" ? opt : opt.label || ""
      }
      loading={loading}
      // if the input is enabled or the user click on the clear option in the input
      onInputChange={(_, value, reason) => (enableInput || reason === 'clear') && handleSearch(value, reason)}
      onChange={(_, value) => enableInput && handleSelect(value)}
      renderInput={(params) => (
        <TextField 
          {...params}
          error={error} 
          size={size} 
          label={label} 
          variant={variant}
          onClick={() => !enableInput && setEnableInput(true)}
        />
      )}
    />
  );
}

MRLocationSearch.propTypes = {
  onSelect: PropTypes.func,
  label: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string
}

MRLocationSearch.defaultProps = {
  onSelect: () => {},
  label: 'Location',
  variant: 'outlined',
  size: 'small',
  error: false,
  value: ''
}

export default MRLocationSearch;